
import React, { createContext, useContext } from "react";
import { format } from "date-fns";
import { enIN } from "date-fns/locale";

const DateFormatContext = createContext();

export const DateFormatProvider = ({ children }) => {
  const formatForDisplay = (date) => {
    try {
      return format(new Date(date), "MMM d, yyyy", { locale: enIN });
    } catch (e) {
      return date;
    }
  };

  const formatForAPI = (date) => {
    try {
      return format(new Date(date), "yyyy-MM-dd");
    } catch (e) {
      return date;
    }
  };

  return (
    <DateFormatContext.Provider value={{ formatForDisplay, formatForAPI }}>
      {children}
    </DateFormatContext.Provider>
  );
};

export const useDateFormat = () => useContext(DateFormatContext);
